import { createFileRoute } from '@tanstack/react-router'
import { FeatureLanding } from './-components/feature-landing'
import { buildSeo } from './-lib/seo'
import { createSiteTranslate } from './-lib/site-i18n'

export const Route = createFileRoute('/(public)/deck-builder')({
	ssr: true,
	head: ({ match }) => {
		const { appLanguage } = match.context
		const t = createSiteTranslate(appLanguage)
		return buildSeo({
			appLanguage,
			path: '/deck-builder',
			title: t('site:seo.deck_builder.title'),
			description: t('site:seo.deck_builder.description')
		})
	},
	component: DeckBuilderPage
})

function DeckBuilderPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = createSiteTranslate(appLanguage)

	return (
		<FeatureLanding
			ctaSubtitle={t('site:landing.download.subtitle')}
			ctaTitle={t('site:deck_builder.cta.title')}
			eyebrow={t('site:deck_builder.hero.eyebrow')}
			features={[
				{
					body: t('site:deck_builder.f1.body'),
					title: t('site:deck_builder.f1.title')
				},
				{
					body: t('site:deck_builder.f2.body'),
					title: t('site:deck_builder.f2.title')
				},
				{
					body: t('site:deck_builder.f3.body'),
					title: t('site:deck_builder.f3.title')
				}
			]}
			lead={t('site:deck_builder.hero.lead')}
			t={t}
			title={t('site:deck_builder.hero.title')}
		/>
	)
}
